// extracted by mini-css-extract-plugin
export default {"cls1":"HW96JuVuuBxM735q_ZDU","cls2":"IayLf4fgnVPW6hkV7qeu HW96JuVuuBxM735q_ZDU","isPhone":"Nx8HM4SP_IWHTCHNaR49"};